export default {
  methods: {
    randomWord(length) {
      if (!length) {
        length = 5;
      }
      let s ='';
      while(s.length < length)
        s += Math.random().toString(36).replace(/\d|_/g,'').slice(2, 12);
      return s.substr(0, length);
    }
  }
}